import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { spotPriceLoader } from "@/lib/spotSnapshot";

const ElpriserPrognos = lazy(() => import("@/pages/elpriser/Prognos"));

export const Route = createFileRoute("/elpriser/prognos")({
  // Spotpriserna hämtas på servern så att tabeller och nyckeltal finns i HTML:en.
  loader: spotPriceLoader,
  head: () => seoHead("/elpriser/prognos", { description: "Skapa ett gratis konto för att ta del av vår AI-prognos som visar elpriser upp till 30 dagar framåt. Företag kan även anmäla intresse för API-access till prognosdata." }),
  component: () => <ElpriserPrognos />,
});
